/*
* Copyright (C) Regione Lombardia
*/
import { Component } from '@angular/core';
import { ViewerService } from '@shared/services/viewer.service';

@Component({
    selector: 'app-shared-pages-router',
    templateUrl: './viewer.component.html',
})
export class PagesViewerComponent {
    
    constructor(
        private viewerService: ViewerService,
    ) { }

    public goToViewer() {
        this.viewerService.getUrlViewer().subscribe((response: any) => window.open(response.urlViewer, 'blank'));
    }

}
